var map = {
	"./fakeData.js": 8796,
	"./fonts/poppins.woff": 1056,
	"./fonts/poppins.woff2": 1611,
	"./icons/10am.svg": 8999,
	"./icons/3pm.svg": 8585,
	"./icons/7pm.svg": 6762,
	"./icons/avatar-default.svg": 7974,
	"./icons/before-sleep.svg": 6662,
	"./icons/bottle-sup.svg": 6680,
	"./icons/breakfast.svg": 8564,
	"./icons/dinner.svg": 2215,
	"./icons/hide.svg": 9261,
	"./icons/home-icon.svg": 4087,
	"./icons/icon-done-2.svg": 1996,
	"./icons/icon-done.svg": 1105,
	"./icons/info.svg": 7292,
	"./icons/lunch.svg": 3838,
	"./icons/show.svg": 4837,
	"./icons/tablet-green-outline.svg": 4970,
	"./icons/tablet-green.svg": 8771,
	"./icons/tablet-icon.svg": 1507,
	"./icons/tablet.svg": 3233,
	"./icons/upon-arising.svg": 6391,
	"./images/attention.png": 8092,
	"./images/confirm-bg.png": 989,
	"./images/en.svg": 9037,
	"./images/error-bg.png": 3048,
	"./images/es.svg": 5893,
	"./images/logo.svg": 2835,
	"./images/logo_drawer.svg": 8527,
	"./images/logo_drawer_short.svg": 1753,
	"./images/registered-bg.png": 9875,
	"./images/slider/slide1.jpeg": 6304,
	"./images/slider/slide2.jpeg": 8457,
	"./images/slider/slide3.jpeg": 4803,
	"./images/spinner.png": 9694,
	"./images/success.svg": 1185,
	"./images/temp-icon.jpg": 583
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6041;